// Lead time calculation utility
export const calculateLeadTime = (quantity, product) => {
    if (!product) return null;

    // Check if product has any thresholds defined
    const hasThresholds = product.threshold1 > 0 || product.threshold2 > 0 || product.threshold3 > 0;

    // No thresholds → use default LeadTime directly (same for any quantity)
    if (!hasThresholds) {
        return product.leadTime ?? null;
    }

    // Threshold-based logic (updated)
    const T1 = product.threshold1 || 0;
    const T2 = product.threshold2 || 0;
    const T3 = product.threshold3 || 0;

    if (quantity >= 1 && quantity <= T1) {
        return product.leadTime1;
    } else if (T2 > 0 && quantity === T2) {
        return product.leadTime2;
    } else if (T3 > 0 && quantity === T3) {
        return product.leadTime3;
    } else {
        // Check if it's beyond the highest defined threshold
        const maxThreshold = T3 > 0 ? T3 : (T2 > 0 ? T2 : T1);
        if (quantity > maxThreshold) {
            return 'MANUAL'; // Beyond thresholds (Valid but manual)
        }

        // Otherwise it's an disallowed intermediate value
        return 'INVALID';
    }
};

// European countries list
export const EUROPEAN_COUNTRIES = [
    'Austria', 'Belgium', 'Bulgaria', 'Croatia', 'Cyprus', 'Czech Republic',
    'Denmark', 'Estonia', 'Finland', 'France', 'Germany', 'Greece', 'Hungary',
    'Ireland', 'Italy', 'Latvia', 'Lithuania', 'Luxembourg', 'Malta',
    'Netherlands', 'Poland', 'Portugal', 'Romania', 'Slovakia', 'Slovenia',
    'Spain', 'Sweden'
];

// List of countries for dropdown
export const COUNTRIES = [
    'India',
    'USA',
    'United Kingdom',
    'Canada',
    'Australia',
    ...EUROPEAN_COUNTRIES,
    'China',
    'Japan',
    'South Korea',
    'Singapore',
    'Malaysia',
    'Thailand',
    'United Arab Emirates',
    'Saudi Arabia',
    'Brazil',
    'Mexico',
    'South Africa'
].sort();

// Indian states
export const INDIAN_STATES = [
    'Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh',
    'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka',
    'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram',
    'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu',
    'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal',
    'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu',
    'Delhi', 'Jammu and Kashmir', 'Ladakh', 'Lakshadweep', 'Puducherry'
];

// Validation helper
export const isEuropeanCountry = (country) => {
    return EUROPEAN_COUNTRIES.includes(country);
};
